module.exports = __webpack_public_path__ + "img/Bangladesh.bb51ee9e.png";